module.exports = __webpack_public_path__ + "img/194.865bb7d7.jpg";